import Axios from './axios'

const pre = process.env.REACT_APP_MORALIS

export function getUsers(params) {
  return Axios.post(`${pre}/users`, params)
}

export function nftLogin(params) {
  return Axios.post(`${pre}/functions/nftLogin`, params)
}

export function topCollection(params) {
  return Axios.post(`${pre}/functions/topCollection`, params)
}

export function addFavorites(params) {
  return Axios.post(`${pre}/functions/addFavorites`, params)
}

export function addFollower(params) {
  return Axios.post(`${pre}/functions/addFollower`, params)
}

export function delFavorites(params) {
  return Axios.post(`${pre}/functions/delFavorites`, params)
}

export function delFollower(params) {
  return Axios.post(`${pre}/functions/delFollower`, params)
}

export function getCollectionDetail(params) {
  return Axios.post(`${pre}/functions/getCollectionDetail`, params)
}

export function getFavorites(params) {
  return Axios.post(`${pre}/functions/getFavorites`, params)
}

export function getFollowee(params) {
  return Axios.post(`${pre}/functions/getFollowee`, params)
}

export function getFollower(params) {
  return Axios.post(`${pre}/functions/getFollower`, params)
}

export function getServerTime(params) {
  return Axios.post(`${pre}/functions/getServerTime`, params)
}

export function getUserCollectionsInfo(params) {
  return Axios.post(`${pre}/functions/getUserCollectionsInfo`, params)
}

export function getUserInvestInfo(params) {
  return Axios.post(`${pre}/functions/getUserInvestInfo`, params)
}

export function getUserCollectionsValue(params) {
  return Axios.post(`${pre}/functions/getUserCollectionsValue`, params)
}

export function getUserCollectionsItems(params) {
  return Axios.post(`${pre}/functions/getUserCollectionsItems`, params)
}

export function getTradeHistory(params) {
  return Axios.post(`${pre}/functions/getTradeHistory`, params)
}

export function isFollowing(params) {
  return Axios.post(`${pre}/functions/isFollowing`, params)
}

export function upsertAccount(params) {
  return Axios.post(`${pre}/functions/upsertAccount`, params)
}
